
      import versionDisplayManager from './utils/version-display-manager.ts';
      
      // Initialize version display manager
      // - Updates version badge
      // - Sets up modal interactions
      // - Logs version to console for bug reports
      versionDisplayManager.init();
    